// Help Center FAQ Content
// Updated with concise, focused FAQs

export const faqCategories = [
  {
    id: 'general',
    label: 'General Questions',
    icon: '❓',
    faqs: [
      {
        question: 'What should I check first when I start my day?',
        answer: 'Start with your dashboard. Review today\'s tasks, calendar events, unread messages, and notifications. This gives you an immediate snapshot of what needs attention. Always prioritize items marked urgent or time-sensitive.',
        cta: { label: 'Open Dashboard', route: '/a-dashboard' }
      },
      {
        question: 'How quickly am I expected to respond to messages?',
        answer: 'Urgent messages should be acknowledged within one hour during working hours. Non-urgent messages should be responded to the same business day whenever possible. If something will take time, acknowledge it and give a timeframe.',
        cta: { label: 'Open Messages', route: '/a-dashboard/exec-messages' }
      },
      {
        question: 'Where do I document meetings and decisions?',
        answer: 'All important meetings, decisions, and follow-ups should be logged using the platform\'s notes or task system. This ensures continuity and visibility for both your executive and admin.',
        cta: { label: 'Open To-Do Center', route: '/a-dashboard/to-do' }
      },
      {
        question: 'What happens if I make a mistake?',
        answer: 'Mistakes happen. Report them immediately, document what occurred, and propose a solution if possible. Early transparency is always preferred over silence.'
      },
      {
        question: 'How do I handle travel planning?',
        answer: 'All travel must be documented in the Travel Binder. Include vendors, confirmation numbers, dates, and contacts. Travel should also be reflected on the calendar automatically.',
        cta: { label: 'Open Travel Binder', route: '/a-dashboard/travel' }
      },
      {
        question: 'Can I communicate outside the platform?',
        answer: 'Use the in-app messaging system whenever possible. Email or external tools should only be used when required for outside parties.',
        cta: { label: 'Open Messages', route: '/a-dashboard/exec-messages' }
      },
      {
        question: 'What if I\'m unsure how to handle a task?',
        answer: 'Ask before proceeding. Clarifying expectations is part of the job and is always encouraged. Contact your executive for task-specific questions or admin for policy clarification.'
      },
      {
        question: 'How is my time tracked?',
        answer: 'Use the Time Clock to clock in and out daily. Manual entries must be submitted for approval if needed. All time entries are visible to admin and subject to review.'
      },
      {
        question: 'Who approves my work or time entries?',
        answer: 'Executives or Admin depending on the workflow. You\'ll see approval status directly in the system. Manual time entries require admin approval before being finalized.'
      },
      {
        question: 'How do I know what\'s expected of me long-term?',
        answer: 'Refer to the Company Policies & Procedures handbook and your performance goals. Reviews and feedback will clarify expectations over time. Performance reviews are conducted quarterly with a comprehensive annual review.'
      }
    ]
  }
];
